import { isNil, isEmpty } from 'ramda';

export const isNilOrEmpty = (N) => isNil(N) || isEmpty(N);
